import { PrimeReactModal } from "@finanedi.es/storybook"
import { authorizeAccountAfterbanks } from "api/Afterbanks.service"
import { insertTarjetaBancaria } from "api/TarjetaBancaria.service"
import { AfterBanksForm } from "./AfterBanksForm"
import {
  PRIME_REACT_MODAL_DEFAULT_PROPS,
  TIPO_TARJETA_AFTERBANKS,
  TipoTarjetaAfterbanksType,
} from "./_constants"
import { AfterBanksResponseProps } from "./_interfaces"

export const AfterBanksModal = ({
  isOpen,
  onClose,
  bankList,
}: {
  isOpen: boolean
  onClose(): void
  bankList: Array<AfterBanksResponseProps | undefined>
}) => {
  return (
    <PrimeReactModal
      header='Vincular tarjeta'
      ptContext={{
        dialog: PRIME_REACT_MODAL_DEFAULT_PROPS.dialog,
      }}
      className='tw-w-5/6 tw-max-w-full tw-h-5/6 tw-max-h-full tw-flex tw-flex-col tw-gap-2'
      visible={isOpen}
      onHide={onClose}
      focusOnShow={false}
      closeOnEscape
    >
      <AfterBanksForm
        banksList={bankList}
        serviceAuthorize={async (props) => {
          const response = await authorizeAccountAfterbanks(props?.formData)
          return response
        }}
        serviceConnect={async (props) => {
          const response = await insertTarjetaBancaria({
            autorizacionTarjetaBancaria: {
              ...props?.formData,
              products:
                typeof props?.formData?.products === "object"
                  ? props?.formData?.products?.product
                  : undefined,
            },
            entidadBancaria: {
              bic: props?.bankSelected?.swift,
              nombre: props?.bankSelected?.fullname,
            },
            nombre:
              typeof props?.formData?.products === "object"
                ? props?.formData?.products?.description
                : undefined,
            tipo:
              typeof props?.formData?.products === "object"
                ? TIPO_TARJETA_AFTERBANKS[
                    props?.formData?.products?.type as TipoTarjetaAfterbanksType
                  ]
                : undefined,
          })

          return response
        }}
        onConnectSuccess={() => {
          onClose()
        }}
      />
    </PrimeReactModal>
  )
}
